module.exports = __webpack_public_path__ + "img/ic_1.7e128e76.png";